import type { IconData } from '@stacksjs/iconify-core'

export const dollarCoin: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3\"/><path d=\"M24 8c8.837 0 16 7.163 16 16s-7.163 16-16 16S8 32.837 8 24S15.163 8 24 8\"/><path d=\"M28.5 18.949S26.7 17.57 24 17.57c-2.25 0-4.5 1.378-4.5 3.215c0 4.591 9 1.836 9 6.428c0 1.837-2.25 3.214-4.5 3.214c-2.7 0-4.5-1.377-4.5-1.377M24 17.571V15m0 18v-2.57\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default dollarCoin
